import { voiceExtractIntentUrl } from "../../config";

export interface VoiceTranscriptionResponse {
  language: string;
  name: string;
  gender: string;
  age: string;
  profession: string;
}

export async function transcribeVoice(audioFile: File): Promise<{ data: VoiceTranscriptionResponse }> {
  const formData = new FormData();
  formData.append("file", audioFile);

  const response = await fetch(voiceExtractIntentUrl, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Voice transcription API error: ${response.statusText} - ${errorText}`);
  }

  const responseData = await response.json();
  
  // Handle different response formats
  // If response already has data property, use it; otherwise wrap the response
  const data = responseData.data || responseData;
  
  // Return in the expected format
  return { data };
}

